// Configuration globale pour l'API
// Set REACT_APP_API_BASE_URL in .env (e.g. http://localhost:5003 for dev, or '' when frontend and API share the same origin)
const getBaseUrl = () => {
  // Check for environment variable first
  if (typeof process !== 'undefined' && process.env?.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  // In development (browser), use direct backend URL since CORS is enabled
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5003';
    }
  }
  // Production: use same origin (or set REACT_APP_API_BASE_URL)
  return '';
};

const API_CONFIG = {
  BASE_URL: getBaseUrl(),
  ENDPOINTS: {
    // User endpoints
    USER: {
      AUTH: '/api/user/auth',
      REGISTER: '/api/user/register',
      LOGOUT: '/api/user/logout',
      FORGOT_PASSWORD: '/api/user/forgot-password',
      RESET_PASSWORD: '/api/user/reset-password',
      VERIFY_EMAIL: '/api/user/verify-email',
      RESEND_VERIFICATION: '/api/user/resend-verification',
      PROFILE: '/api/user/getProfile',
      UPDATE_PROFILE: '/api/user/profile',
      ASSIGN_ROLE: '/api/user/assignrole',
      TOTAL_USERS: '/api/user/total',
      ALL: '/api/user/all',
      SEARCH_USERS: '/api/user/search-users',
      FILTERED_RESTAURANTS: '/api/user/filtered',
      SEARCH_RESTAURANTS: '/api/user/search',
      GET_RESTAURANT_BY_ID: '/api/user/restaurant',
      GET_ALL_RESTAURANTS: '/api/user/getAllRestaurants',
      GET_ALL_RESTAURANTS_PAGI: '/api/user/getAllRestaurantsPagi',
      GET_TOTAL_RESTAURANTS: '/api/user/getTotalRestaurants',
      COUNTRIES: '/api/user/countries',
      DIETS: '/api/user/diets',
      SYSTEM_SETTINGS: '/api/user/system-settings',
      SITE_THEME: '/api/user/site-theme',
      OAUTH_SESSION: '/api/user/oauth-session',
    },
    // Restaurant endpoints
    RESTAURANT: {
      ADD_MENU: '/api/restaurant/addMenu',
      GET_MENUS: '/api/restaurant/menus',
      GET_ALL_MENUS: '/api/restaurant/getAllmenus',
      GET_ALL_MENUS_PAGI: '/api/restaurant/getAllmenusPagi',
      GET_MENU_BY_ID: '/api/restaurant/getMenu',
      GET_MENU_BY_USER_ID: '/api/restaurant/getMenuByUserId',
      MODIFY_MENU: '/api/restaurant/modifyMenu',
      DELETE_MENU: '/api/restaurant/deleteMenu',
      FILTER_MENUS: '/api/restaurant/filterMenus'
    },
    // Recipe endpoints
    RECIPE: {
      ADD_RECIPE: '/api/recipe/addRecipe',
      GET_RECIPES: '/api/recipe/getRecipes',
      GET_ALL_RECIPES: '/api/recipe/getRecipes',
      GET_RECIPE_LIST: '/api/recipe/getRecipeList',
      GET_ALL_RECIPES_PAGI: '/api/recipe/getAllrecipePagi',
      GET_RECIPE_BY_ID: '/api/recipe/getRecipe',
      GET_RECIPE_BY_USER_ID: '/api/recipe/recipes',
      MODIFY_RECIPE: '/api/recipe/modifyRecipe',
      DELETE_RECIPE: '/api/recipe/deleteRecipe',
      FILTER_RECIPES: '/api/recipe/filter'
    },
    // Notification endpoints
    NOTIFICATION: {
      LIST: '/api/notifications',
      MARK_ALL_READ: '/api/notifications/mark-all/read',
      MARK_READ_BASE: '/api/notifications'
    },
    // Survey endpoints
    SURVEY: {
      CREATE: '/api/survey/create',
      GET_ALL: '/api/survey/all',
      GET_BY_ID: '/api/survey',
      UPDATE: '/api/survey',
      DELETE: '/api/survey',
      SUBMIT_RESPONSE: '/api/survey'
    },
    // Stats endpoints
    STATS: {
      GET_OVERVIEW: '/api/stats/overview',
      GET_FILTERED_OVERVIEW: '/api/stats/overview/filtered',
      GET_USER_STATS: '/api/stats/users',
      GET_CONTENT_STATS: '/api/stats/content',
      GET_SURVEY_STATS: '/api/stats/surveys',
      GET_GEOGRAPHIC_DATA: '/api/stats/geographic',
      EXPORT_ALL: '/api/stats/export',
      EXPORT_BY_TYPE: '/api/stats/export',
      EXPORT_STATS: '/api/stats/export-stats',
      DATA_QUALITY: '/api/stats/data-quality',
      DATA_QUALITY_ISSUES: '/api/stats/data-quality/issues',
      DATA_QUALITY_RULES: '/api/stats/data-quality/rules',
      DATA_DOMAINS: '/api/stats/domains',
      DATA_DOMAIN_BY_TYPE: '/api/stats/domains',
      // New dynamic endpoints
      VALIDATE_DATA: '/api/stats/validate',
      VALIDATION_STATS: '/api/stats/validation-stats',
      REAL_TIME_DASHBOARD: '/api/stats/real-time-dashboard',
      LIVE_ACTIVITY: '/api/stats/live-activity',
      DYNAMIC_FILTERS: '/api/stats/dynamic-filters',
      APPLY_FILTERS: '/api/stats/apply-filters',
      SYSTEM_HEALTH: '/api/stats/system-health',
      PERFORMANCE_METRICS: '/api/stats/performance-metrics',
      CONSUMPTION_STATS: '/api/stats/consumption'
    }
  },
  // Helper function to get full URL
  getFullUrl: (endpoint) => {
    return `${API_CONFIG.BASE_URL}${endpoint}`;
  },
  // Uploaded paths need BASE_URL; OAuth avatars (Google) are already absolute URLs
  resolveImageUrl: (imagePath) => {
    if (!imagePath) return '';
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    return `${API_CONFIG.BASE_URL}${imagePath}`;
  },
  // Helper function to get user endpoint
  getUserEndpoint: (endpoint) => {
    return API_CONFIG.getFullUrl(API_CONFIG.ENDPOINTS.USER[endpoint]);
  },
  // Helper function to get restaurant endpoint
  getRestaurantEndpoint: (endpoint) => {
    return API_CONFIG.getFullUrl(API_CONFIG.ENDPOINTS.RESTAURANT[endpoint]);
  },
  // Helper function to get recipe endpoint
  getRecipeEndpoint: (endpoint) => {
    return API_CONFIG.getFullUrl(API_CONFIG.ENDPOINTS.RECIPE[endpoint]);
  },
  // Helper function to get survey endpoint
  getSurveyEndpoint: (endpoint) => {
    return API_CONFIG.getFullUrl(API_CONFIG.ENDPOINTS.SURVEY[endpoint]);
  },
  // Helper function to get stats endpoint
  getStatsEndpoint: (endpoint) => {
    return API_CONFIG.getFullUrl(API_CONFIG.ENDPOINTS.STATS[endpoint]);
  }
};

export default API_CONFIG;
